import createIcon from '../../createIcon';

/**
 * @component @name VideoCameraFront
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTAuNDhWNkMxOCA0LjkgMTcuMSA0IDE2IDRINEMyLjkgNCAyIDQuOSAyIDZWMThDMiAxOS4xIDIuOSAyMCA0IDIwSDE2QzE3LjEgMjAgMTggMTkuMSAxOCAxOFYxMy41MkwyMiAxNy41VjYuNUwxOCAxMC40OFpNMTAgOEMxMS4xIDggMTIgOC45IDEyIDEwQzEyIDExLjEgMTEuMSAxMiAxMCAxMkM4LjkgMTIgOCAxMS4xIDggMTBDOCA4LjkgOC45IDggMTAgOFpNMTQgMTZINlYxNS40M0M2IDE0LjYyIDYuNDggMTMuOSA3LjIyIDEzLjU4QzguMDcgMTMuMjEgOS4wMSAxMyAxMCAxM0MxMC45OSAxMyAxMS45MyAxMy4yMSAxMi43OCAxMy41OEMxMy41MiAxMy45IDE0IDE0LjYyIDE0IDE1LjQzVjE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VideoCameraFront = createIcon('VideoCameraFront', [
  [
    'path',
    {
      d: 'M18 10.48V6C18 4.9 17.1 4 16 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H16C17.1 20 18 19.1 18 18V13.52L22 17.5V6.5L18 10.48ZM10 8C11.1 8 12 8.9 12 10C12 11.1 11.1 12 10 12C8.9 12 8 11.1 8 10C8 8.9 8.9 8 10 8ZM14 16H6V15.43C6 14.62 6.48 13.9 7.22 13.58C8.07 13.21 9.01 13 10 13C10.99 13 11.93 13.21 12.78 13.58C13.52 13.9 14 14.62 14 15.43V16Z',
      key: '1t3ewt',
    },
  ],
]);

export default VideoCameraFront;
